import React from 'react';
import { Section, SectionHeading } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { ContentIcon } from '../ui/ContentIcon';
import { CountUp } from '../ui/CountUp';
import { proofItems } from '../../data/content';
export function ProofStack() {
  return <Section className="bg-mist" aria-labelledby="ciencia-titulo" data-id="element-289" data-mp="rn9jjdzp0bkd">
      <Reveal data-id="element-290" data-mp="rlewnu4v29dn">
        <SectionHeading id="ciencia-titulo" data-id="element-291" data-mp="rl57u9vjy89j">Por qué funciona (la ciencia)</SectionHeading>
      </Reveal>

      <ul className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-292" data-mp="csbnob5c53yj">
        {proofItems.map((item, index) => <Reveal as="li" key={item.title} delay={index * 0.06} className="list-none" data-id="element-293" data-mp="hmz5jr5u3045" data-mpi={index}>
            <article className="flex h-full flex-col border-l-4 border-gold bg-white p-6 shadow-card transition-[transform,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:shadow-lift sm:p-7" data-id="element-294" data-mp="3r55lxn1fl36">
              <span className="text-forest" data-id="element-295" data-mp="1y18rkemlscrt">
                <ContentIcon name={item.icon} className="h-6 w-6" data-id="element-296" data-mp="232odsa0iopbs" />
              </span>
              <h3 className="mt-5 text-base font-bold text-forest" data-id="element-297" data-mp="3lto64dgkkpoy">{item.title}</h3>
              {item.counter !== undefined && <p className="mt-2 text-4xl font-extrabold tracking-tight text-gold" data-id="element-298" data-mp="3hte0j1wow1am">
                  <CountUp value={item.counter} suffix={item.counterSuffix} data-id="element-299" data-mp="3vkirlflzrl9c" />
                </p>}
              <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-300" data-mp="3qkebvrswquk6">{item.description}</p>
            </article>
          </Reveal>)}
      </ul>
    </Section>;
}